/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Comments/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2ChatBubble from 'DesignSystem/Svgs/Tysiav2ChatBubble/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Comments({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/Board/Board/Content/Card/Comments"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let cardCommentsAggregateAggregateCountValueData = fromData.useDataValue({ viewPath,
context: 'card',
path: 'comments_aggregate.aggregate.count',
})
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<div
  data-testid="Comments.Horizontal"
  data-view-path={viewPath}
 title="View comments"
 style={{'--g-1-ZCPene': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<Tysiav2ChatBubble
  viewPath={`${viewPath}/Tysiav2ChatBubble`}
 width={14}
 height={14}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral600}
 size="small"
 weight="medium"
 data="card.comments_aggregate.aggregate.count"
 text={cardCommentsAggregateAggregateCountValueData}
/>
</div>
{children}
</React.Fragment>)
}